import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'xux-drag-icon',
  templateUrl: './xux-drag-icon.component.html',
  styleUrls: ['./xux-drag-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxDragIconComponent implements OnInit {
  public constructor() {}

  public ngOnInit() {}
}
